<div class="modal-header">
  <h4 class="modal-title"> {{'header.options.language' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="container overflow-xh" style="min-height: 100px">
      @for(language of languages; track $index) {
        <div class="form-check mb-1">
          <input class="form-check-input" type="radio" name="languages" [id]="language.langCode" [value]="language" [(ngModel)]="currentLanguage">
          <label class="form-check-label" [for]="language.langCode">
            {{language.langNativeName}}
          </label>
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="changeLanguage()">{{'global.label.ok' | translate}}</button>
</div>
